import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  useListTodosQuery,
  useClaimTodoMutation,
  useCompleteTodoMutation,
} from '../../redux/api/todoApi';
import { useApiErrorToast } from '../../hooks/useApiError';
import TodoCard from './TodoCard';

const FILTERS = [
  { key: 'open', label: 'Offen' },
  { key: 'mine', label: 'Meine' },
  { key: 'done', label: 'Erledigt' },
];

const MobileTodoList = () => {
  const currentEvent = useSelector((state) => state.auth.currentEvent);
  const [filter, setFilter] = useState('open');
  const apiErrorToast = useApiErrorToast();

  const queryArgs = useMemo(() => {
    const args = { eventId: currentEvent?.id };
    if (filter === 'open') args.status = 'OPEN,IN_PROGRESS';
    if (filter === 'mine') args.mine = true;
    if (filter === 'done') args.status = 'DONE';
    return args;
  }, [filter, currentEvent?.id]);

  const {
    data: todos,
    isLoading,
    isFetching,
    refetch,
  } = useListTodosQuery(queryArgs, {
    skip: !currentEvent?.id,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const [claim] = useClaimTodoMutation();
  const [complete] = useCompleteTodoMutation();

  const handleClaim = async (id) => {
    try {
      await claim(id).unwrap();
      toast.success('Übernommen');
    } catch (err) {
      apiErrorToast(err, 'Übernehmen fehlgeschlagen');
      refetch();
    }
  };
  const handleComplete = async (id) => {
    try {
      await complete(id).unwrap();
      toast.success('Erledigt');
    } catch (err) {
      apiErrorToast(err, 'Erledigen fehlgeschlagen');
    }
  };

  if (!currentEvent?.id) {
    return (
      <div className='container px-2 py-3'>
        <div className='alert alert-info'>
          Bitte zuerst ein Event auswählen.
        </div>
      </div>
    );
  }

  return (
    <div className='container px-2 py-2'>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <h5 className='mb-0'>{currentEvent.name}</h5>
        <button
          className='btn btn-sm btn-outline-secondary'
          onClick={refetch}
          disabled={isFetching}
        >
          <i className='fas fa-arrows-rotate' />
        </button>
      </div>

      <div className='btn-group w-100 mb-3' role='group'>
        {FILTERS.map((f) => (
          <button
            key={f.key}
            type='button'
            style={{ minHeight: 44 }}
            className={`btn ${filter === f.key ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <p>Wird geladen…</p>
      ) : (todos || []).length === 0 ? (
        <div className='alert alert-light text-center'>Keine Aufgaben.</div>
      ) : (
        todos.map((t) => (
          <TodoCard
            key={t.id}
            todo={t}
            onClaim={handleClaim}
            onComplete={handleComplete}
            mobile
          />
        ))
      )}
    </div>
  );
};

export default MobileTodoList;
